//import AirDatepicker from 'air-datepicker';
//import localeSl from '../lib/air-datepicker-language/sl';
//import localeEn from 'air-datepicker/locale/en';
//import PhotoSwipeLightbox from 'photoswipe/lightbox';


// function setDatePickerInput(){

// 	var datepicker = $('.datepicker');
	
// 	if(!datepicker.length){
// 		return;
// 	}

// 	var interfaceLng = $('html').attr('lang');
// 	var options = {
// 		container: ".form-group-datetime",
// 		locale: interfaceLng == 'sl' ? localeSl : localeEn,
// 		position: 'bottom left',
// 		autoClose: true,
// 		classes: 'acm-datepicker',
// 		dateFormat: 'dd.MM.yyyy',
// 		multipleDatesSeparator: ' - '
// 	};

// 	datepicker.each(function(){
// 		var elementId = $(this).attr('id');
// 		new AirDatepicker(`#${elementId}`, options);
// 	});
// }


// function photoSwipe(){
// 	const lightbox = new PhotoSwipeLightbox({
// 		gallery: '#photoswipe-gallery',
// 		children: 'a',
// 		pswpModule: () => import('photoswipe')
// 	});
// 	lightbox.on('uiRegister', function() {
// 		lightbox.pswp.ui.registerElement({
// 			name: 'custom-caption',
// 			order: 9,
// 			isButton: false,
// 			appendTo: 'root',
// 			html: 'Caption text',
// 			onInit: (el, pswp) => {
// 			lightbox.pswp.on('change', () => {
// 				const currSlideElement = lightbox.pswp.currSlide.data.element;
// 				let captionHTML = '';
// 				if (currSlideElement) {
// 				const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
// 				if (hiddenCaption) {
// 					// get caption from element with class hidden-caption-content
// 					captionHTML = hiddenCaption.innerHTML;
// 				} else {
// 					// get caption from alt attribute
// 					captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
// 				}
// 				}
// 				el.innerHTML = captionHTML || '';
// 			});
// 			}
// 		});
// 	});
// 	lightbox.init();
// }


/**
 * 
 * @param {array} aParams 
 * @param {array} aExcluded 
 * @param {function} callback 
 */
 function callAjax(url = '', type = 'GET', className, method, oParams, aExcluded, callback){	
	$.ajax({
		url: `${url}?ajax=1`,
		type: type,
		data: {'method': method, 'class': className, 'params':oParams},
		success: function(data){
			if(data == ''){
				return;
			}

			if(callback){
				callback(data);
			}

			if(type === 'GET'){
				var params = `${createParamsString(oParams, aExcluded)}`;
				if (history && params.length){
					history.pushState(null, null, '?' + params);
				}
			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown) { 
			// console.log("Status: " + textStatus);
			// console.log("Error: " + errorThrown); 
		}
 	});

	function createParamsString(oParams, aExcluded){
		return Object.keys(oParams)
				.filter((key) => aExcluded.indexOf(key) === -1)
				.reduce((joined, current) => {
					if(oParams[current] === null){
						return joined;
					}
					return joined + `&${current}=${oParams[current]}`
				}, '').substring(1);
	}
}

// function enabledInputFieldOnCheckbox(){
// 	$('input[type="checkbox"]').on('click', function(){
// 		var name = $(this).data('name') + '[withText]';
// 		var input = $(`input[name="${name}"]`);

// 		if(input.length){
// 			input.val("");
// 			input.prop('disabled') ? input.prop('disabled', false) : input.prop('disabled', true);
// 		}
	
// 	});
// }

// function enabledInputFieldOnRadioButton(){
// 	$('input[type="radio"]').on('click', function(){
// 		var name = $(this).data('name');
// 		var inputSelector = `input[name="${name}[withText]"]`;
// 		// remove input if radio is selected because otherwise hidden input overide radio value
// 		//$(`input[type="hidden"][name="${name}[value]"]`).remove();

// 		if($(inputSelector).length){
// 			$(inputSelector).prop('disabled', true);
// 			$(inputSelector).val("");
// 			var input = $(this).closest('.checkbox-label').find(inputSelector);
			
// 			if(input.prop('disabled')){
// 				input.prop('disabled', false);
// 			}
// 		}
// 	});
// }

// function setSimplePagination(){
// 	var selector = $('.auto-pagination');
	
// 	if(selector.length < 1){
// 		return;
// 	}
	
// 	//page parameter mast allways be last parameter
// 	var currentParams = new URLSearchParams(window.location.search).toString();
// 	currentParams = '?' + currentParams;

// 	if(currentParams != '?' && !currentParams.includes('?page=') && !currentParams.includes('&page=')){
// 		currentParams = currentParams + '&page=';
// 	}else if(currentParams.includes('&page=')){
// 		currentParams = currentParams.slice(0,currentParams.indexOf('&page=')+6);
// 	}else{
// 		currentParams = '?page=';
// 	}

// 	selector.pagination({
// 		items: selector.attr('data-total'),
// 		itemsOnPage: selector.attr('data-limit'),
// 		currentPage : selector.attr('data-current'),
// 		nextText: '<img src="/assets/images/icons/right-arrow.svg" alt="">',
// 		prevText: '<img src="/assets/images/icons/left-arrow.svg" alt="">',
// 		hrefTextPrefix: currentParams
// 	});
// }

// nastavi invisible recaptcho za vse forme in jo pokliče na submit forme
window.captchaCallback = function(){
	var widgetAttr = 'data-widgetid';
	var recaptchaClass = '.g-recaptcha';
	var recaptchaRespons = '.g-recaptcha-response';
	$(recaptchaClass).each(function(index, el) {
		var form = $(el).closest("form");
		var widgetId = grecaptcha.render(el, {
			'sitekey' : jQuery(el).attr('data-sitekey'), 
			'callback' : token => {
				form.find(recaptchaRespons).val(token);
				form.trigger("submit");
			}
		});
		$(el).attr(widgetAttr, widgetId);
	});

	$('.arctur-form [type=submit]').on('click', function(ev) {
		ev.preventDefault();
		var widgetId = $(this).closest('form').find(recaptchaClass).attr(widgetAttr);
		grecaptcha.execute(widgetId);
	});
}

function playYoutubeVideo(){
	$('.video-overlay').on('click', function(){
		var video = '<div class="videoHolder ratio ratio-16x9"><iframe src="' + $(this).attr('data-video').replace('www.youtube.com/watch?v=', 'www.youtube-nocookie.com/embed/') +'?autoplay=1" allow="autoplay"></iframe></div>';
		$(this).html(video);
	});
}

function commentsCarousel(){
	$('.testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 700,
		prevArrow: '<button type="button" class="slick-prev pull-left" aria-label="prev"><img width="42" height="23" src="/assets/images/arrow.svg" alt=""></button>',
		nextArrow: '<button type="button" class="slick-next pull-right" aria-label="next"><img width="42" height="23" src="/assets/images/arrow.svg" alt=""></button>',
	});
}


$.fn.spasticNavTabs = function(options) {
		
	options = $.extend({
		overlap: 20,
		speed: 300,
		reset: 200
	}, options);
	
	return this.each(function() {
		
		var nav = $(this),
		currentPageItem = $('.active', nav),
		blob,
		reset;
		
		var bleft, bwidth, shouldHide = false;
		if (currentPageItem.length > 0 && currentPageItem.position()) {
			bwidth = currentPageItem.outerWidth();
			bleft = currentPageItem.position().left;
		} else {
			shouldHide = true;
		}
		$('<div class="blob"></div>').css({
			width: bwidth,
			left: bleft
		}).appendTo(this);
		
		blob = $('.blob', nav);
		
		if (shouldHide) {
			blob.css('opacity', '0');
		}
		
		$(nav).on('mouseleave', function() {
			if (shouldHide) blob.css('opacity', 0);
		});
		
		$('.nav-link', nav).on('click', function() {
			// mouse over
			clearTimeout(reset);
			blob.animate({
				left: $(this).position().left,
				width: $(this).width(),
				opacity: 1
			}, {
				duration: options.speed,
				easing: options.easing,
				queue: false
			});
		});
	}); // end each
};

$.fn.spasticNavMenu = function(options) {
	
	options = $.extend({
		overlap: 20,
		speed: 300,
		reset: 200
	}, options);
	
	return this.each(function() {
		
		var nav = $(this),
		currentPageItem = $('.nav-link.bs-level-1.active', nav),
		blob,
		reset;
	
		var bleft, bwidth, shouldHide = false;
		if (currentPageItem.length > 0 && currentPageItem.position()) {
			bwidth = currentPageItem.outerWidth();
			bleft = currentPageItem.parent().position().left;
		} else {
			shouldHide = true;
		}
		
		$('<li class="blob"></li>').css({
			width: bwidth,
			left: bleft
		}).appendTo(this);
		blob = $('.blob', nav);
		
		if (shouldHide) {
			blob.css('opacity', '0');
		}
		
		$('.nav-item.bs-level-1', nav).on('mouseenter', function() { // mouse over
			clearTimeout(reset);
			blob.animate({
				left: $(this).position().left,
				width: $(this).width(),
				opacity: 1
			}, {
				duration: options.speed,
				easing: options.easing,
				queue: false
			});
		}).on('mouseleave', function() { // mouse out
			reset = setTimeout(function() {
				if (shouldHide) {
					blob.stop(true,true);
					blob.css('opacity', 0);
				}else{
					blob.animate({
						width: bwidth,
						left: bleft
					}, options.speed)
				}
			}, options.reset);
		});
		
		$(nav).on('mouseleave', function() {
			if (shouldHide) {
				blob.stop(true,true);
				blob.css('opacity', 0);
			}
		});
		
	}); // end each
};

function openVideoPopup(){
	var dialog = '';

	$('.openVideo').on('click', function() {
		var openVideoDialog = $(this).data("videoModal");
		var html = '<div class="dialog-video ratio ratio-16x9"><iframe src="' + $(this).attr('data-video').replace('www.youtube.com/watch?v=', 'www.youtube-nocookie.com/embed/') +'?autoplay=1" allow="autoplay"></iframe></div><div class="close-dialog"><img src="/assets/images/icons/close.svg"></div>';
		dialog = document.getElementById(openVideoDialog);
		dialog.insertAdjacentHTML('beforeend',html);
		dialog.showModal();
	});

	$(document).on('click', '.close-dialog', function() {
		dialog.innerHTML = '';
		dialog.close();
	});
}

function animations(){

	const durationBottom = 2000;
	const durationSide = 1100;
	const distance = '50px';
	
	ScrollReveal().reveal('.item.item__right', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.item.item__left', { mobile: false, duration: durationSide, distance: distance, origin: 'left' });
	ScrollReveal().reveal('.text-field', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.chars-component', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.main-header-wrapper .text', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.main-header-wrapper .citat', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.video-overlay.right', { mobile: false, duration: durationSide, distance: distance, origin: 'left' });
	ScrollReveal().reveal('.video-overlay.left', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.title-component h2', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.quote-content', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.image-right', { mobile: false, duration: durationSide, distance: distance, origin: 'left' });
	ScrollReveal().reveal('.codebook-list__list-grid-line', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('.codebook-list__list-grid-dots', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('body#body-content main .content-wrapper p', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });
	ScrollReveal().reveal('body#body-content main .content-wrapper ul', { mobile: false, duration: durationSide, distance: distance, origin: 'right' });

	ScrollReveal().reveal('.content-columns-wrapper a', Object.assign({}, { mobile: false, distance: '20%', origin: 'bottom'}, { delay: 0, interval: 300 }));
	ScrollReveal().reveal('.codebook-list.codebook-list__tags .codebook-item', Object.assign({}, { mobile: false, distance: '20%', origin: 'bottom'}, { delay: 0, interval: 300 }));

	stepShowingTabItems();

	$('.nav.nav-tabs .nav-link').on('click', function(){
		stepShowingTabItems();
	});
}

function stepShowingTabItems(){
	$('.tab-pane .items .item').removeClass('show');
		
	const items = document.querySelectorAll('.tab-pane.active .items .item');
	var timeouts = [];
	var delay = 100;
	
	for (var i=0; i < timeouts.length; i++) {
		clearTimeout(timeouts[i]);
	}
	
	items.forEach(item => {
		timeouts[i] = setTimeout(() => {
			item.classList.add('show');
		}, delay);
		delay += 300;
		i++;
	});
}

function openMobileMenu(){
	$('.open-main-menu').on('click', function(){
		$('.line-1, .line-2, .line-3').toggleClass('move');
		$('.mobile-menu').toggleClass('show-mob');
		$('body').toggleClass('overflow');
	});
}

function escapeClose(){
    $(document).on('keyup', function(e){
        if(e.which == 27){
            $('.line-1, .line-2, .line-3').removeClass('move');
			$('.mobile-menu').removeClass('show-mob');
			$('body').removeClass('overflow');
			$('.dialog-video').remove();
			$('.close-dialog').remove();
        }
    });
}

function expandePriceBox(){
	$('.open-arrow').on('click', function(){
		$(this).parent().toggleClass('expand');
	});
}

function onSelectionChange(){
	$('.tabs-select').on('change', function(){
		var panelId = $(this).val();
		console.log(panelId);
		$('.tab-pane.fade').removeClass('active');
		$('.tab-pane.fade').removeClass('show');
		$(`#${panelId}`).addClass('active show');
		stepShowingTabItems();
	});
}

function focusFirstFormError(){
	if($('form').length){
		var fieldId = $('[aria-invalid="true"]').first().attr('id');
		$(`#${fieldId}`).trigger('focus');
	}
}

function closeDialogWindow(){
	document.querySelectorAll('dialog').forEach(element => 
		element.addEventListener('mousedown', event => {
				if (event.target === event.currentTarget) {
					event.currentTarget.close();
					$('.dialog-video').remove();
					$('.close-dialog').remove();
				}
			}
		)
	)
}

$(function($) {

	//setDatePickerInput();
	//photoSwipe();
	//enabledInputFieldOnCheckbox();
	//enabledInputFieldOnRadioButton();
	//setSimplePagination();
	require("./main-menu-bootstrap");
	playYoutubeVideo();
	commentsCarousel();
	openVideoPopup();
	animations();
	openMobileMenu();
	expandePriceBox();
	onSelectionChange();
	focusFirstFormError();
	escapeClose();
	closeDialogWindow();
	
	$('.nav-tabs').spasticNavTabs();
	$('.main-menu').spasticNavMenu();
	//acmLogout();

	//var params = {id:'as', id2:5, strId:4};
	var params = {};

	// callAjax('','GET', 'Acm\\Classes\\Test', 'getAjax', params, ['id2'], function(jqueryHtml){
	// 	$('main').append(jqueryHtml);
	// });

	// callAjax('','POST', 'Acm\\Modules\\NwsController', 'getNewsList1', params, [], function(data){
	// 	$('.news-list').append($(data));
	// 	console.log(data);
	// });

});


